/* unplugin-vue-components disabled */import { render } from "./AlertDialog.vue?vue&type=template&id=08652ddd&scoped=true&ts=true"
import script from "./AlertDialog.vue?vue&type=script&lang=ts"
export * from "./AlertDialog.vue?vue&type=script&lang=ts"

import "./AlertDialog.vue?vue&type=style&index=0&id=08652ddd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08652ddd"]])

export default __exports__